import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { useEffect, useState } from 'react';

import Home from './pages/Home';
import Navbar from './components/Navbar';
import MainFooter from './components/MainFooter';
import AboutPage from './pages/AboutPage';
import ContactPage from './pages/ContactPage';
import Preloader from './components/Preloader';
import ProductPage from './components/ProductPage';
import Infrastructure from './pages/Infrastructure';
import ScrollToTop from './components/ScrollToTop';
function App() {
  const [loading, setLoading] = useState(true);
  const [showContent, setShowContent] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
      setTimeout(() => setShowContent(true), 300); 
    }, 1500);

    return () => clearTimeout(timer);
  }, []);

  return (
    <>
      {loading && <Preloader />}

      {/* 1. BrowserRouter must wrap everything so Navbar links work */}
      <BrowserRouter basename='/'>
      
        {/* 2. Navbar is moved OUTSIDE the .app-wrapper div */}
        {/* Now it ignores the transform property and stays fixed to the window */}
        {!loading && <Navbar />} 

        <ScrollToTop />
        {/* 3. The wrapper now only handles the page content animation */}
        <div className={`app-wrapper ${showContent ? 'show' : ''}`}>
          
          <main className="app-main">
            <Routes >
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<AboutPage />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/products" element={<ProductPage />} />
              <Route path="/products/:id" element={<ProductPage />} />
              <Route path="/infrastructure" element={<Infrastructure />} />
            </Routes>
          </main>

          {showContent && <MainFooter />}
        </div>
        
      </BrowserRouter>
    </>
  );
}

export default App;